import { USDC_HYPERCORE_PERP_ID } from '../../constants/tokenIds'
import { e8sToDecimals } from '../../utils/validationHelper'
import useBalances from '../useBalances'

// Available USDC in the HyperCore perp account, read from the usdc-hypercore-perp
// token balance (via ledgerscanner) instead of a separate clearinghouse fetch.
// Open positions / total account value still come from `perpsAccountBalance`.
const usePerpAvailableBalance = () => {
  const { findBalance } = useBalances()
  const perpBalance = findBalance({ id: USDC_HYPERCORE_PERP_ID })

  if (!perpBalance) return 0

  return e8sToDecimals(perpBalance.balance, perpBalance.token.decimals)
}

export default usePerpAvailableBalance
